import {READ_MESSAGE, SET_MESSAGES} from "../actions/type";

const initialState ={
    items:[],
    unread:0,
};

export default function massages(state = initialState , action = {}) {
    switch (action.type) {
        case SET_MESSAGES :
            const { messages } = action;
            let unread = messages.filter( item => item.status !== 'viewed' ).length;
            return {
                items:messages,
                unread,
                };
        case READ_MESSAGE :
            const { id } = action;
            let newUnread =state.unread -1;
            let items = state.items;
            let message = items.filter( item => item.id === id )[0];
            message['status'] ="viewed";

            return {
                items:items,
                newUnread,
            };
        default:
            return state;
    }
};